import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  SkeletonNewCardComponent,
  SkeletonNewCardHorizontalComponent,
  SkeletonNewPrincipalImageComponent,
} from './components';

@Component({
  selector: 'app-skeleton-news-page',
  standalone: true,
  imports: [
    CommonModule,
    SkeletonNewPrincipalImageComponent,
    SkeletonNewCardComponent,
    SkeletonNewCardHorizontalComponent,
  ],
  templateUrl: './skeleton-news-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonNewsPageComponent {
  cardItem = Array.from({ length: 3 });
}
